import React, { useState, useEffect } from "react";
import "./styles.scss";
import "./styles-v2.scss";
import "./styles--v2.scss";
import {
  resizeVideos,
  debounce,
  checkImage,
  imgCrop,
  getMediaDevice,
  imageDimensionSet
} from "../../helpers";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import YouTubeEmbed from "../../dynamic/YouTube";

// const itemsToDisplay = { DESKTOPXL: 3, DESKTOP: 3, TABLET: 2, MOBILE: 1 };

interface image {
  cropKey: string;
  imageUrl: string | null;
}

interface slide {
  backgroundImage: image[];
  title: string;
  subtext: string;
  videoId: string;
  duration: number;
  startTime: number;
  loop: boolean;
  fade?: boolean;
  linkUrl?: string | null;
  linkTarget?: string | null;
  textAlign?: string;
  ctaText?: string;
  buttonColor?: string;
  buttonTextColor?: string;
  chevronColor?: string;
}

const getImageSize = ({ slide, size }: { slide: slide; size: string }) => {
  return slide.backgroundImage.some(image => image.cropKey == size)
    ? slide.backgroundImage.filter(
        (image: { cropKey: string; imageUrl: string }) => image.cropKey == size
      )[0].imageUrl
    : "";
};

const Slides = ({
  page,
  itemsPerPage,
  slides
}: {
  page: number;
  itemsPerPage: number;
  slides: slide[];
}) => {
  const slicedItems = slides.slice(
    page * itemsPerPage,
    (page + 1) * itemsPerPage
  );

  const [fade, setVideoFade] = useState(true);
  const visibility = !fade ? "hidden" : "visible";
  const imageRatio = 0.433;

  return (
    <ReactCSSTransitionGroup
      transitionName="carousel__animation"
      transitionEnterTimeout={500}
      transitionLeaveTimeout={500}
      className={`carousel__animation-container`}
    >
      {slicedItems.map((slide: slide) =>
        slide.videoId !== "" ? (
          <div
            className={`page__${page || 0} homepage-hero-grid__image--main`}
            key={
              getImageSize({
                slide,
                size: "Small"
              }) || Math.ceil(Math.random() * 100000)
            }
          >
            <a
              href={`${slide.linkUrl}`}
              target={slide.linkTarget != null ? slide.linkTarget : ""}
              className={`homepage-hero-grid__image-bg${
                slide.textAlign ? ` align-${slide.textAlign}` : ""
              }`}
              style={{
                backgroundImage: `url(${
                  !fade
                    ? getImageSize({
                        slide,
                        size: "Small"
                      })
                    : ""
                })`
              }}
            >
              <div className="homepage-hero-grid__description">
                <p className="homepage-hero-grid__cta-title">{slide.subtext}</p>
                <h6>{slide.title}</h6>
                {slide.ctaText ? (
                  <p
                    style={{
                      background: `#${slide.buttonColor}`,
                      color: `#${slide.buttonTextColor}`
                    }}
                    className={`homepage-hero-grid__cta-text`}
                  >
                    {slide.ctaText}
                  </p>
                ) : null}
              </div>
            </a>
            <div
              className="homepage-hero-grid__video-background"
              style={{
                visibility
              }}
            >
              <YouTubeEmbed
                view={"mobile"}
                id={slide.videoId}
                containerClassName={`video-background__video-container ${
                  fade ? "show" : "hide"
                }`}
                onReady={({ target }: { target: EventTarget }) => {
                  // @ts-ignore
                  target.mute();
                  setInterval(() => {
                    // @ts-ignore
                    target.seekTo(slide.startTime ? slide.startTime : 0);
                    setVideoFade(false);
                  }, (slide.duration ? slide.duration : 10) * 1000);
                }}
              />
            </div>
          </div>
        ) : (
          <div
            className={`page__${page || 0} homepage-hero-grid__image--main`}
            key={`${getImageSize({
              slide,
              size: "Small"
            })}${slide.title}`}
          >
            <a
              href={`${slide.linkUrl}`}
              target={slide.linkTarget != null ? slide.linkTarget : ""}
              className="homepage-hero-grid__image-bg"
              style={{
                backgroundImage: `url(${imageDimensionSet({
                  url: getImageSize({
                    slide,
                    size: getMediaDevice() == "MOBILE" ? "Small" : "Large"
                  }),
                  width:
                    getMediaDevice() == "MOBILE"
                      ? 960
                      : document.body.clientWidth,
                  height:
                    getMediaDevice() == "MOBILE"
                      ? 1200
                      : document.body.clientWidth * imageRatio
                })})`
              }}
            >
              <div className="homepage-hero-grid__description">
                <p className="homepage-hero-grid__cta-title">{slide.subtext}</p>
                <h6>{slide.title}</h6>
                {slide.ctaText ? (
                  <p
                    style={{
                      background: `#${slide.buttonColor}`,
                      color: `#${slide.buttonTextColor}`
                    }}
                    className={`homepage-hero-grid__cta-text`}
                  >
                    {slide.ctaText}
                  </p>
                ) : null}
              </div>
            </a>
          </div>
        )
      )}
    </ReactCSSTransitionGroup>
  );
};

import { Carousel } from "../../dynamic/Carousel/Carousel";

const itemsToDisplay = { DESKTOPXL: 1, DESKTOP: 1, TABLET: 1, MOBILE: 1 };

export interface GenericHeroProps {
  slide: slide;
  index?: number;
  setFadeout?: any;
}

const chevronSvg = (color: string = "") =>
  `url("data:image/svg+xml,<%3Fxml version='1.0' encoding='UTF-8'%3F><svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 75.79 22.66'><defs><style> .cls-1 { fill: %23${color}; } </style></defs><polygon class='cls-1' points='0 22.66 13.2 22.66 23.65 0 10.45 0 0 22.66'/><polygon class='cls-1' points='26.07 22.66 39.27 22.66 49.72 0 36.52 0 26.07 22.66'/><polygon class='cls-1' points='52.14 22.66 65.34 22.66 75.79 0 62.59 0 52.14 22.66'/></svg>") no-repeat`;

export const GenericHero = ({
  slide,
  index = 0,
  setFadeout
}: GenericHeroProps) => {
  const id = Math.random()
    .toString()
    .slice(3);

  const head = document.head;
  let stylesNode = document.querySelector("#carousel-styles");
  const { buttonColor = "", buttonTextColor = "" } = slide;
  const styles = `
      .brand--world-tennis .grid__module .page__${index}.homepage-hero-grid__image--main a:before,
      .brand--world-tennis .grid__module .page__${index}.homepage-hero-grid__image--main a:after 
        { ${"background: " +
          (slide.chevronColor
            ? chevronSvg(slide.chevronColor) + " bottom left"
            : "url() transparent") +
          ";"} }
      .brand--world-tennis .grid__module .page__${index}.homepage-hero-grid__image--main a:after 
        { ${"background: " +
          (slide.chevronColor
            ? chevronSvg(slide.chevronColor) + " top right"
            : "url() transparent") +
          ";"} }
      .brand--world-tennis .grid__module .page__${index} .homepage-hero-grid__cta-text 
        { ${"background: #" +
          buttonColor.replace("#", "") +
          "; color: #" +
          buttonTextColor.replace("#", "") +
          ";"} }
      `;

  if (!stylesNode && head) {
    stylesNode = document.createElement("style");
    stylesNode.id = `carousel-styles-${index}`;
    stylesNode.innerHTML = styles;
    head.appendChild(stylesNode);
  }

  useEffect(() => {
    debounce({
      func: () =>
        resizeVideos({
          ElClassName: `video-background__video-container.desktop`
        })
    });
    resizeVideos({ ElClassName: `video-background__video-container.desktop` });
  }, []);
  return (
    <>
      <div
        key={index}
        style={
          index === 0
            ? {
                backgroundImage: `url(${getImageSize({
                  slide,
                  size: index === 0 ? "Large" : "Medium"
                })})`
              }
            : {}
        }
        className={`page__0 homepage-hero-grid__image${
          index === 0 ? "--main" : ""
        }${
          slide.videoId && index === 0
            ? ` video-background ${slide.fade ? "hide" : "show"}`
            : ""
        }`}
      >
        {slide.videoId !== "" && index === 0 && !slide.fade ? (
          <>
            <div>
              <div
                className={`homepage-hero-grid__image-bg${
                  slide.textAlign ? ` align-${slide.textAlign}` : ""
                }`}
              >
                <a
                  target={slide.linkTarget != null ? slide.linkTarget : ""}
                  href={`${slide.linkUrl}`}
                  className="homepage-hero-grid__description"
                >
                  <div className="homepage-hero-grid__cta-title">
                    {slide.subtext}
                  </div>
                  <h6>{slide.title}</h6>
                  {slide.ctaText ? (
                    <div
                      style={{
                        background: `#${slide.buttonColor}`,
                        color: `#${slide.buttonTextColor}`
                      }}
                      className="homepage-hero-grid__cta-text"
                    >
                      {slide.ctaText}
                    </div>
                  ) : null}
                </a>
              </div>
              <YouTubeEmbed
                view={"desktop"}
                id={slide.videoId}
                containerClassName={`video-background__video-container desktop show ${id}`}
                onReady={({ target }: any) => {
                  target.mute();
                  if (slide.loop) {
                    setInterval(() => {
                      target.seekTo(slide.startTime ? slide.startTime : 0);
                    }, (slide.duration ? slide.duration : 10) * 1000);
                  } else {
                    target.seekTo(slide.startTime ? slide.startTime : 0);
                    setTimeout(() => {
                      setFadeout({ index });
                    }, slide.duration * 1000);
                  }
                }}
                onEnd={() => {
                  setFadeout({ index });
                }}
              />
            </div>
          </>
        ) : (
          <a
            href={`${slide.linkUrl}`}
            target={slide.linkTarget != null ? slide.linkTarget : ""}
            className={`homepage-hero-grid__image-bg${
              slide.textAlign ? ` align-${slide.textAlign}` : ""
            }`}
            style={
              index !== 0
                ? {
                    backgroundImage: `url(${getImageSize({
                      slide,
                      size: index === 0 ? "Large" : "Medium"
                    })})`
                  }
                : {}
            }
          >
            {index === 0 ? (
              <div className="homepage-hero-grid__description">
                <div className="homepage-hero-grid__cta-title">
                  {slide.subtext}
                </div>
                <h6>{slide.title}</h6>
                {slide.ctaText && slide.ctaText.length > 0 ? (
                  <div
                    style={{
                      background: `#${slide.buttonColor}`,
                      color: `#${slide.buttonTextColor}`
                    }}
                    className="homepage-hero-grid__cta-text"
                  >
                    {slide.ctaText}
                  </div>
                ) : null}
              </div>
            ) : null}
          </a>
        )}

        {index === 0 ? null : (
          <div className="homepage-hero-grid__description">
            <a
              href={`${slide.linkUrl}`}
              target={slide.linkTarget != null ? slide.linkTarget : ""}
              className="homepage-hero-grid__cta-title"
            >
              {slide.title}
            </a>
          </div>
        )}
      </div>
      <a
        target={slide.linkTarget != null ? slide.linkTarget : ""}
        href={`${slide.linkUrl}`}
        className="homepage-hero-grid__description mobile"
      >
        <div className="homepage-hero-grid__cta-title">{slide.subtext}</div>
        <h6>{slide.title}</h6>
        {slide.ctaText ? (
          <div
            style={{
              background: `#${slide.buttonColor}`,
              color: `#${slide.buttonTextColor}`
            }}
            className="homepage-hero-grid__cta-text"
          >
            {slide.ctaText}
          </div>
        ) : null}
      </a>
    </>
  );
};

interface GenericCTAProps {
  title: string;
  subtitle: string;
  buttonText: string;
  buttonLink: string;
  buttonTarget: string;
  buttonColor: string;
  backgroundImage: imgCrop[];
  logoImage: imgCrop[];
}

export const GenericCTA = ({
  title,
  subtitle,
  buttonText,
  buttonLink,
  buttonTarget,
  buttonColor,
  backgroundImage,
  logoImage
}: GenericCTAProps) => (
  <div
    className="generic-cta"
    style={{
      backgroundImage: `url(${process.env.HOST}${checkImage({
        images: backgroundImage,
        size: "Large"
      })})`
    }}
  >
    <div>
      <div
        style={{
          backgroundImage: `url(${process.env.HOST}${checkImage({
            images: logoImage,
            size: "Small"
          })})`
        }}
        className="generic-cta__logo"
      />
      {title ? <p className="generic-cta__title">{title}</p> : null}
      {subtitle ? <p className="generic-cta__subtitle">{subtitle}</p> : null}
      {buttonText ? (
        <a
          href={buttonLink}
          target={buttonTarget}
          className={`generic-cta__button ${buttonColor}`}
        >
          {buttonText}
        </a>
      ) : null}
    </div>
  </div>
);

export const HomepageHero = ({
  mode = 0,
  mainStoryButtonText,
  mainStoryButtonUrl,
  mainStoryButtonTarget,
  bottomLinkText,
  bottomLinkUrl,
  bottomLinkTarget,
  slides
}: {
  mode?: number;
  mainStoryButtonText?: string;
  mainStoryButtonUrl?: string;
  mainStoryButtonTarget?: string;
  bottomLinkText?: string;
  bottomLinkUrl?: string;
  bottomLinkTarget?: string;
  slides: slide[];
}) => {
  const [Tiles, updateTiles] = useState<slide[]>(slides);

  const setFadeout = ({ index }: { index: number }) => {
    const newTiles = Tiles.map((t, i) => {
      const newTile = i === index ? { ...t, fade: true } : t;
      return newTile;
    });
    updateTiles(newTiles);
  };

  const props = {
    setFadeout
  };

  const head = document.head;
  let stylesNode = document.querySelector("#carousel-styles");
  const styles = slides.reduce((str, slide, key) => {
    const { buttonTextColor = "ffffff", buttonColor = "000000" } = slide;
    return `${str}
      .brand--world-tennis .page__${key}.homepage-hero-grid__image--main a:before,
      .brand--world-tennis .page__${key}.homepage-hero-grid__image--main a:after 
        { ${"background: " +
          (slide.chevronColor
            ? chevronSvg(slide.chevronColor) + " bottom left"
            : "url() transparent") +
          ";"} }
      .brand--world-tennis .page__${key}.homepage-hero-grid__image--main a:after 
        { ${"background: " +
          (slide.chevronColor
            ? chevronSvg(slide.chevronColor) + " top right"
            : "url() transparent") +
          ";"} }
      .brand--world-tennis .page__${key} .homepage-hero-grid__cta-text 
        { ${"background: #" +
          buttonColor.replace("#", "") +
          "; color: #" +
          buttonTextColor.replace("#", "") +
          ";"} }
      `;
  }, "");

  if (!stylesNode && head) {
    stylesNode = document.createElement("style");
    stylesNode.id = "carousel-styles";
    stylesNode.innerHTML = styles;
    head.appendChild(stylesNode);
  }

  const mainStoryBtn = (): null | JSX.Element => {
    return mainStoryButtonText && mainStoryButtonText.length > 0 ? (
      <a
        className="homepage-hero-grid__main-btn"
        href={mainStoryButtonUrl}
        target={mainStoryButtonTarget}
      >
        {mainStoryButtonText}
      </a>
    ) : null;
  };

  const bottomLink = (): null | JSX.Element => {
    return bottomLinkText && bottomLinkText.length > 0 ? (
      <div className="homepage-hero-grid__more-btn">
        <a
          className="homepage-hero-grid__more-btn"
          href={bottomLinkUrl}
          target={bottomLinkTarget}
        >
          {bottomLinkText}
        </a>
      </div>
    ) : null;
  };

  const [worldTennisBrand, isWorldTennisBrand] = useState(false);

  useEffect(() => {
    const flag = !!document.querySelector(".brand--world-tennis");
    isWorldTennisBrand(flag);
  }, [worldTennisBrand]);

  return (
    <>
      {worldTennisBrand ? null : (
        <section className="hide--mobile">
          <div
            className={`container homepage-hero-grid${
              mode === 1 ? " homepage-hero-grid--alt" : ""
            } ${
              (slides.length === 3 || slides.length == 4) && mode === 0
                ? `homepage-hero-grid--${slides.length - 1}`
                : ""
            }`}
          >
            {mainStoryBtn()}
            {Tiles.map((slide, index) => (
              <GenericHero slide={slide} index={index} {...props} />
            ))}
            {bottomLink()}
          </div>
        </section>
      )}
      <section
        className={
          worldTennisBrand ? "carousel-module" : "hide--tablet hide--desktop"
        }
      >
        <div className="homepage-hero-grid">
          {mainStoryBtn()}
          <Carousel
            totalItems={slides.length}
            itemsToDisplay={itemsToDisplay}
            pagerPerItem
          >
            <Slides
              page={0}
              slides={slides}
              itemsPerPage={itemsToDisplay["DESKTOP"]}
            />
          </Carousel>
          {bottomLink()}
        </div>
      </section>
    </>
  );
};

export const HomepageMainImage = ({ slide }: { slide: slide }) => (
  <div className="homepage-main-image">
    <GenericHero slide={slide} />
  </div>
);

export default HomepageHero;
